"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAddressString = exports.isAddressString = void 0;
const isAddressString = (input) => typeof input == "string" && /^.*,\s?\d{4}\s[\p{L}\s]+$/iu.test(input);
exports.isAddressString = isAddressString;
const parseAddressString = (input) => {
    if (typeof input != "string" && !(0, exports.isAddressString)(input))
        return input;
    const [, street, zip, place] = input.match(/^(.*),\s?(\d{4})\s([\p{L}\s]+)$/iu) ?? [];
    return [street, zip, place];
};
exports.parseAddressString = parseAddressString;
